import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
const blink = keyframes `
  0%, 20% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;
const LoaderContainer = styled.div `
  display: flex;
  align-items: center;
`;
const Dot = styled.span `
  animation: ${blink} 1.4s infinite steps(1, end);
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
export const LoadingDots = () => (_jsxs(LoaderContainer, { children: [_jsx(Dot, { children: "." }), _jsx(Dot, { children: "." }), _jsx(Dot, { children: "." })] }));
